import { get, post } from './axios'
import { whatsappBusinessAccount } from './whatsapp-business-account'
import { z } from 'zod'

const syncWhatsappBusinessAccountResponse = z.object({
    message: z.string(),
})

export function fetchWhatsappBusinessAccounts() {
    return get(whatsappBusinessAccount.array(), '/whatsapp-business-accounts')
}

export function fetchWhatsappBusinessAccount(accountId: string) {
    return get(whatsappBusinessAccount, `/whatsapp-business-accounts/${accountId}`)
}

export function syncWhatsappBusinessAccount(accountId: string) {
    return post(syncWhatsappBusinessAccountResponse, `/whatsapp-business-accounts/${accountId}/sync`, {})
}
